import { render } from "./SearchHeaderCom.vue?vue&type=template&id=8c194668"
import script from "./SearchHeaderCom.vue?vue&type=script&lang=js"
export * from "./SearchHeaderCom.vue?vue&type=script&lang=js"

import "./SearchHeaderCom.vue?vue&type=style&index=0&id=8c194668&lang=css"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__